
import { Component, Mixins } from "vue-property-decorator";
import { PaintStyle } from "../../../../../../base/domain/drawing";
import { IPaintStylePropertyEditable, instanceOfIPaintStylePropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class PaintStylePropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IPaintStylePropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IPaintStylePropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isPaintStyleEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIPaintStylePropertyEditable(s) && s.paintStyle().isEditable(), false);
  }

  get paintStyle(): PaintStyle {
    return this.readPropertyOrDefault(s => PaintStyle.from(s.paintStyle().getValue()), new PaintStyle());
  }

  set paintStyle(value: PaintStyle) {
    this.writePropertyWhenValid(s => s.paintStyle().setValue(PaintStyle.to(value)));
  }
}
